import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePartyBasics, partyKeys } from '@/services/parties'
import type { UpdatePartyBasicsInput } from '@/types'

export function useUpdatePartyBasics(partyId: string) {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (updates: UpdatePartyBasicsInput) => updatePartyBasics(partyId, updates),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: partyKeys.detail(partyId) })
      queryClient.invalidateQueries({ queryKey: partyKeys.detailWithData(partyId) })
      queryClient.invalidateQueries({ queryKey: partyKeys.byNation(data.nation_id) })
      queryClient.invalidateQueries({ queryKey: partyKeys.myParties() })
      queryClient.invalidateQueries({ queryKey: partyKeys.myPartiesWithDetails() })
    },
  })

  return {
    updateBasics: mutation.mutate,
    updateBasicsAsync: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    error: mutation.error,
  }
}
